// extracted by mini-css-extract-plugin
export default {"categoryView":"category_view_categoryView__8DlE3"};